
import { ReactComponent as StarsIcon } from "assets/svgs/stars.svg";
import { ChartScatter, SquareUser } from "lucide-react";
import SidebarAudioIcon from "components/icons/sidebar-audio-icon";
import SidebarNotesIcon from "components/icons/sidebar-notes-icon";
import SidebarTutorialIcon from "components/icons/sidebar-tutorial-icon";
import SidebarTemplateIcon from "components/icons/sidebar-template-icon";

export const SIDEBAR_ITEMS = (isOpen) => {
  return [
    {
      to: "/audio-check",
      label: "Audio Check",
      icon: <SidebarAudioIcon isOpen={isOpen} />,
    },
    {
      to: "/create-notes",
      label: "Create Notes",
      icon: <SidebarNotesIcon isOpen={isOpen} />,
    },
    {
      to: "/templates",
      label: "Templates",
      icon: <SidebarTemplateIcon isOpen={isOpen} />,
    },
    {
      to: "/tutorial",
      label: "Tutorial",
      icon: <SidebarTutorialIcon isOpen={isOpen} />,
    },
  ];
};

export const RAINBOW_COLORS = [
  "#def9fa",
  "#bef3f5",
  "#9dedf0",
  "#7de7eb",
  "#5ce1e6",
  "#33bbcf",
];

export const MEDICAL_PROFESSIONS = [
  // Medical Practitioners
  { id: 1, name: "General Practitioner", category: "Medical Practitioners" },
  { id: 2, name: "Emergency Physician", category: "Medical Practitioners" },
  { id: 3, name: "Anaesthetist", category: "Medical Practitioners" },
  { id: 4, name: "Intensivist", category: "Medical Practitioners" },
  { id: 5, name: "Cardiologist", category: "Medical Practitioners" },
  { id: 6, name: "Dermatologist", category: "Medical Practitioners" },
  { id: 7, name: "Endocrinologist", category: "Medical Practitioners" },
  { id: 8, name: "Gastroenterologist", category: "Medical Practitioners" },
  { id: 9, name: "Geriatrician", category: "Medical Practitioners" },
  { id: 10, name: "Haematologist", category: "Medical Practitioners" },
  { id: 11, name: "Infectious Disease Physician", category: "Medical Practitioners" },
  { id: 12, name: "Nephrologist", category: "Medical Practitioners" },
  { id: 13, name: "Neurologist", category: "Medical Practitioners" },
  { id: 14, name: "Obstetrician & Gynaecologist", category: "Medical Practitioners" },
  { id: 15, name: "Oncologist (Medical)", category: "Medical Practitioners" },
  { id: 16, name: "Oncologist (Radiation)", category: "Medical Practitioners" },
  { id: 17, name: "Ophthalmologist", category: "Medical Practitioners" },
  { id: 18, name: "Orthopaedic Surgeon", category: "Medical Practitioners" },
  { id: 19, name: "Otolaryngologist (ENT)", category: "Medical Practitioners" },
  { id: 20, name: "Paediatrician", category: "Medical Practitioners" },
  { id: 21, name: "Psychiatrist", category: "Medical Practitioners" },
  { id: 22, name: "Rehabilitation Physician", category: "Medical Practitioners" },
  { id: 23, name: "Respiratory Physician", category: "Medical Practitioners" },
  { id: 24, name: "Rheumatologist", category: "Medical Practitioners" },
  { id: 25, name: "Surgeon (General)", category: "Medical Practitioners" },
  { id: 26, name: "Surgeon (Cardiothoracic)", category: "Medical Practitioners" },
  { id: 27, name: "Surgeon (Neurosurgeon)", category: "Medical Practitioners" },
  { id: 28, name: "Surgeon (Paediatric)", category: "Medical Practitioners" },
  { id: 29, name: "Surgeon (Plastic & Reconstructive)", category: "Medical Practitioners" },
  { id: 30, name: "Surgeon (Vascular)", category: "Medical Practitioners" },
  { id: 31, name: "Urologist", category: "Medical Practitioners" },
  { id: 32, name: "Pain Medicine Specialist", category: "Medical Practitioners" },
  { id: 33, name: "Palliative Care Physician", category: "Medical Practitioners" },
  { id: 34, name: "Public Health Physician", category: "Medical Practitioners" },
  { id: 35, name: "Sports & Exercise Physician", category: "Medical Practitioners" },
  { id: 36, name: "Occupational & Environmental Medicine Physician", category: "Medical Practitioners" },
  
  // Nursing & Midwifery
  { id: 37, name: "Registered Nurse", category: "Nursing & Midwifery" },
  { id: 38, name: "Nurse Practitioner", category: "Nursing & Midwifery" },
  { id: 39, name: "Enrolled Nurse", category: "Nursing & Midwifery" },
  { id: 40, name: "Midwife", category: "Nursing & Midwifery" },
  { id: 41, name: "Practice Nurse", category: "Nursing & Midwifery" },
  { id: 42, name: "Clinical Nurse Specialist", category: "Nursing & Midwifery" },
  { id: 43, name: "Clinical Nurse Consultant", category: "Nursing & Midwifery" },
  { id: 44, name: "Diabetes Educator", category: "Nursing & Midwifery" },
  
  // Allied Health Therapists
  { id: 45, name: "Physiotherapist", category: "Allied Health Therapists" },
  { id: 46, name: "Occupational Therapist", category: "Allied Health Therapists" },
  { id: 47, name: "Speech Pathologist", category: "Allied Health Therapists" },
  { id: 48, name: "Exercise Physiologist", category: "Allied Health Therapists" },
  { id: 49, name: "Dietitian", category: "Allied Health Therapists" },
  { id: 50, name: "Podiatrist", category: "Allied Health Therapists" },
  { id: 51, name: "Chiropractor", category: "Allied Health Therapists" },
  { id: 52, name: "Osteopath", category: "Allied Health Therapists" },
  { id: 53, name: "Audiologist", category: "Allied Health Therapists" },
  { id: 54, name: "Orthotist/Prosthetist", category: "Allied Health Therapists" },
  { id: 55, name: "Music Therapist", category: "Allied Health Therapists" },
  { id: 56, name: "Art Therapist", category: "Allied Health Therapists" },
  { id: 57, name: "Massage Therapist", category: "Allied Health Therapists" },
  { id: 58, name: "Genetic Counsellor", category: "Allied Health Therapists" },
  { id: 59, name: "Lactation Consultant", category: "Allied Health Therapists" },
  
  // Mental Health Professionals
  { id: 60, name: "Psychologist", category: "Mental Health Professionals" },
  { id: 61, name: "Clinical Psychologist", category: "Mental Health Professionals" },
  { id: 62, name: "Counsellor", category: "Mental Health Professionals" },
  { id: 63, name: "Psychotherapist", category: "Mental Health Professionals" },
  { id: 64, name: "Social Worker (Mental Health)", category: "Mental Health Professionals" },
  
  // Diagnostic & Technical Services
  { id: 65, name: "Radiologist", category: "Diagnostic & Technical Services" },
  { id: 66, name: "Sonographer", category: "Diagnostic & Technical Services" },
  { id: 67, name: "Medical Imaging Technologist", category: "Diagnostic & Technical Services" },
  { id: 68, name: "Nuclear Medicine Technologist", category: "Diagnostic & Technical Services" },
  { id: 69, name: "Radiation Therapist", category: "Diagnostic & Technical Services" },
  { id: 70, name: "Pathologist", category: "Diagnostic & Technical Services" },
  { id: 71, name: "Medical Laboratory Scientist", category: "Diagnostic & Technical Services" },
  { id: 72, name: "Medical Laboratory Technician", category: "Diagnostic & Technical Services" },
  { id: 73, name: "Cardiac Technician", category: "Diagnostic & Technical Services" },
  { id: 74, name: "Neurophysiology Technician", category: "Diagnostic & Technical Services" },
  { id: 75, name: "Sleep Scientist", category: "Diagnostic & Technical Services" },
  { id: 76, name: "Perfusionist", category: "Diagnostic & Technical Services" },
  
  // Oral Health
  { id: 77, name: "Dentist", category: "Oral Health" },
  { id: 78, name: "Dental Hygienist", category: "Oral Health" },
  { id: 79, name: "Dental Therapist", category: "Oral Health" },
  { id: 80, name: "Oral Health Therapist", category: "Oral Health" },
  
  // Pharmacy
  { id: 81, name: "Pharmacist", category: "Pharmacy" },
  { id: 82, name: "Pharmacy Technician", category: "Pharmacy" },
  
  // Optical & Hearing
  { id: 83, name: "Optometrist", category: "Optical & Hearing" },
  { id: 84, name: "Orthoptist", category: "Optical & Hearing" },
  { id: 85, name: "Hearing Aid Specialist", category: "Optical & Hearing" },
  
  // Emergency & Retrieval
  { id: 86, name: "Paramedic", category: "Emergency & Retrieval" },
  { id: 87, name: "Intensive Care Paramedic", category: "Emergency & Retrieval" },
  { id: 88, name: "Flight Paramedic", category: "Emergency & Retrieval" },
  
  // Community & Social Care
  { id: 89, name: "NDIS Support Coordinator", category: "Community & Social Care" },
  { id: 90, name: "Aged Care Worker", category: "Community & Social Care" },
  { id: 91, name: "Disability Support Worker", category: "Community & Social Care" },
  { id: 92, name: "Aboriginal & Torres Strait Islander Health Practitioner", category: "Community & Social Care" },
  
  // Complementary & Integrative Health
  { id: 93, name: "Acupuncturist", category: "Complementary & Integrative Health" },
  { id: 94, name: "Naturopath", category: "Complementary & Integrative Health" },
  { id: 95, name: "Traditional Chinese Medicine Practitioner", category: "Complementary & Integrative Health" },
];

export const SAMPLE_TEMPLATES = [
  { id: 1, name: "Template A" },
  { id: 2, name: "Template B" },
  { id: 3, name: "Template C" },
];

export const NON_DASHBOARD_PAGES = ["/login", "/register", "/forgot-password", "/onboarding-audio-check", "/setup-profile"];

export const PAYMENT_STATUS_DECLINED = "declined";

export const tutorialData = [
  {
    sectionTitle: "How to create patient notes?",
    tutorials: [
      {
        title: "'Create Notes' tab",
        description:
          "This tutorial demonstrates how you can use NirvaScribe to create patient notes.",
        videoUrl: "https://nirva-srcibe-content.s3.ap-southeast-2.amazonaws.com/tutorials-video/Create+Notes+Demo+video.mov",
      },
    ],
  },

  {
    sectionTitle: "Setting up your Audio",
    tutorials: [
      {
        title: "'Audio Check' tab",
        description:
          "This tutorial demonstrates how you can set up your audio settings before starting your sessions with your patients.",
        videoUrl: "https://nirva-srcibe-content.s3.ap-southeast-2.amazonaws.com/tutorials-video/Audio+Check+Demo+video.mov",
      },
    ],
  },

  {
    sectionTitle: "Creating Custom Templates",
    tutorials: [
      {
        title: "'Templates' tab",
        description:
          "This tutorial demonstrates how you can set up your own custom templates to generate notes according to your style, format, and order.",
        videoUrl: "https://nirva-srcibe-content.s3.ap-southeast-2.amazonaws.com/tutorials-video/Create%2BCustom%2BTemplate%2Bvideo.mov",
      },
    ],
  },
  {
    sectionTitle: "How to use Telehealth mode?",
    tutorials: [
      {
        title: "'Create Notes' tab",
        description:
          "This tutorial demonstrates how you can use telehealth mode using Nirva, for any of your online consultations.",
        videoUrl: "https://nirva-srcibe-content.s3.ap-southeast-2.amazonaws.com/tutorials-video/Telehealth+Tutorial+video.mov",
        resourceLink: "https://www.nirvascribe.com/nirvascribe-for-telehealth-consultations",
      },
    ],
  },
];
// custom templates
// Fill a doc feature
// 20 sec intro video

export const DEFAULT_TEMPLATE_IDs = process.env.REACT_APP_DEFAULT_TEMPLATE_IDs.split(',').map(id => Number(id));

export const WORKLETCODE_PLACEHOLDER = `class PCMProcessor extends AudioWorkletProcessor {
  process(inputs, outputs, parameters) {
    const input = inputs[0];
    if (input.length > 0) {
      const float32Data = input[0];
      
      // Convert Float32 to Int16
      const int16Data = new Int16Array(float32Data.length);
      for (let i = 0; i < float32Data.length; i++) {
        const s = Math.max(-1, Math.min(1, float32Data[i]));
        int16Data[i] = s < 0 ? s * 0x8000 : s * 0x7FFF;
      }
      
      // Send data to the main thread
      this.port.postMessage(int16Data.buffer, [int16Data.buffer]);
    }
    return true; // Keep processor alive
  }
}
registerProcessor('pcm-processor', PCMProcessor);`

export const MODES = [
  {
    title: 'In-person Mode',
    icon: <ChartScatter size={15}/>
  },
  {
    title: 'Telehealth Mode',
    icon: <SquareUser size={15} />
  },
]

// Languages supported by Deepgram nova-3 multilingual code switching (language=multi).
// "auto" — Deepgram detects any of the 10 supported languages automatically.
// Exactly these 10 language codes are supported; others will not be transcribed.
export const LANGUAGE_OPTIONS = [
  { code: "auto", label: "Auto-detect", shortLabel: "Auto" },
  { code: "en",   label: "English",     shortLabel: "EN"   },
  { code: "es",   label: "Spanish",     shortLabel: "ES"   },
  { code: "fr",   label: "French",      shortLabel: "FR"   },
  { code: "de",   label: "German",      shortLabel: "DE"   },
  { code: "hi",   label: "Hindi",       shortLabel: "HI"   },
  { code: "ru",   label: "Russian",     shortLabel: "RU"   },
  { code: "pt",   label: "Portuguese",  shortLabel: "PT"   },
  { code: "ja",   label: "Japanese",    shortLabel: "JA"   },
  { code: "it",   label: "Italian",     shortLabel: "IT"   },
  { code: "nl",   label: "Dutch",       shortLabel: "NL"   },
]

export const EOFY_SALE_END_DATE = new Date("2026-07-31T23:59:00+10:00");
// Original (full) prices — shown with strikethrough during EOFY sale
export const ORIGINAL_PRICES = {
  monthly: "AUD 150",
  annual: "AUD 120",   // per month, billed annually
};
 
// EOFY sale prices — the discounted prices shown to the user
export const EOFY_SALE_PRICES = {
  monthly: "AUD 120",
  annual: "AUD 100",   // per month, billed annually
};
 
// Discount label shown on toggle badge
export const EOFY_DISCOUNT_LABEL = "EOFY 20% Off";
export const SHOW_EOFY_BANNER = new Date() <= EOFY_SALE_END_DATE;

export const UPGRADE_PROMPT_SESSION_MILESTONES = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60];